import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { getEnv } from "@/hooks/useEnv";
import locales from "@/locales/locales";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  // options: https://www.i18next.com/overview/configuration-options

  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "de"],
    debug: getEnv("VITE_ENV") !== "prod",
    ns: ["default"],
    defaultNS: "default",
    resources: locales,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      skipOnVariables: false,
      prefix: `{`,
      suffix: `}`,
    },
    returnNull: true,
    returnObjects: true,
    joinArrays: ", ",
  });

export default i18n;
